import { GroupCard } from "./GroupCard";
import { Link } from "react-router-dom";
import { useDynamicHeight } from "@customHooks/useDynamicHeight";
import { Group } from "../types";
import { encodeURIComponent as encodeURI } from "@lib/utils";

interface GroupsListProps {
    searchQuery: string;
    isLoading: boolean;
    filteredGroups: Group[];
}

export const GroupsList = ({ searchQuery, isLoading, filteredGroups }: GroupsListProps) => {
    const { ref, height } = useDynamicHeight(isLoading);

    if (isLoading) {
        return (
            <div className="mt-3">
                <div className="flex items-center justify-center p-10">
                    <p className="text-gray-500">Loading groups...</p>
                </div>
            </div>
        );
    }

    return (
        <div
            className="flex flex-col gap-1 flex-1 mt-3 overflow-auto"
            ref={ref}
            style={{
                maxHeight: `${height}px`,
            }}
        >
            {filteredGroups.length ? (
                filteredGroups.map((group) => (
                    <Link
                        to={`/dashboard/groups/${encodeURI(group.id)}?city=${encodeURI(group.city)}`}
                        key={`${group.id}-${group.city}`}
                    >
                        <GroupCard group={group} />
                    </Link>
                ))
            ) : (
                <p className="text-center text-gray-500 p-10">
                    No groups found for the search query {searchQuery}.
                </p>
            )}
        </div>
    );
};
